import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useParamountAuth } from 'context/ParamountAuthContext'
import { getCompanyById } from 'services/clients.svc'
import './CompanyRejected.scss'

export default function CompanyRejected() {
  const { userCompanyId } = useParamountAuth()
  
  const { data: company, isLoading } = useQuery(
    ['company', userCompanyId],
    () => getCompanyById(userCompanyId)
  )

  if (isLoading) {
    return <div aria-busy="true">Loading...</div>
  }

  return (
    <div className="company-rejected-container">
      <div className="status-header">
        <h1>Company Registration Status</h1>
        <div className="status-badge rejected">
          <span>❌ Registration Rejected</span>
        </div>
      </div>
      
      <div className="rejection-message">
        <h2>Registration Not Approved</h2>
        <p>Unfortunately, your company registration for <strong>{company.name}</strong> was not approved.</p>
        
        {company.rejectionReason && (
          <div className="rejection-reason">
            <h3>Reason:</h3>
            <p>{company.rejectionReason}</p>
          </div>
        )}
        
        {company.rejectedAt && (
          <p className="rejection-date">
            <em>Decision made on: {new Date(company.rejectedAt).toLocaleDateString()}</em>
          </p>
        )}
      </div>
      
      <div className="next-steps">
        <h3>Next Steps:</h3>
        <ul>
          <li>Please review the reason provided above</li>
          <li>Address any issues mentioned in the feedback</li>
          <li>You may resubmit your application once concerns are resolved</li>
          <li>Contact our support team if you need clarification</li>
        </ul>
      </div>
      
      <div className="contact-support">
        <h3>Need Help?</h3>
        <p>If you have any questions about this decision or need further assistance, please visit our Contact Us page for support options and phone numbers:</p>
        <a href="https://paramountprestart.com/contact/" className="support-button" target="_blank" rel="noopener noreferrer">
          Contact Us
        </a>
      </div>
    </div>
  )
}